export const RBE_SECTIONS = {
  SOLO_EVENT_SECTION: 'solo-event-section',
  GLOBAL_EVENT_SECTION: 'global-event-section',
};
